import { observer } from "mobx-react";
import { useState } from "react";
import { VBox } from "@/components-v2/Box";
import { useTranslation, useUserStore } from "@/stores/RootStoreContext";
import { capitalize } from "@/utils/strings";
import { ContentBox, LoginLayout, LoginMethodButton, loginMethods } from "./loginComponents";
import { LoginMethod } from "./loginDomain";

const SsoReauthRequiredPage = observer(function SsoReauthRequiredPage() {
  const { t } = useTranslation();
  const userStore = useUserStore();
  const [activeMethod, setActiveMethod] = useState<LoginMethod>();
  const methods = loginMethods.filter(([method]) =>
    userStore.requiredSsoProviders.includes(method),
  );
  const ssoName = methods.map(([method]) => capitalize(method)).join(" / ");
  const account = userStore.requiredSsoAccountNames.join(", ");

  const reauthenticate = (method: LoginMethod) => {
    setActiveMethod(method);
    location.href = `/api/auth/${method}?mode=REAUTH&returnTo=/portfolio`;
  };

  return (
    <LoginLayout>
      <VBox textAlign="center">
        <h1 className="text-h3">{t({ key: "ssoReauth.title", params: { ssoName } })}</h1>
      </VBox>
      <ContentBox gap={"xl"}>
        <div>{t({ key: "ssoReauth.body", params: { account } })}</div>
        <VBox gap={"md"}>
          {methods.map(([method, icon, label]) => (
            <LoginMethodButton
              key={method}
              id={method}
              icon={icon}
              label={label}
              onClick={() => reauthenticate(method)}
              loading={activeMethod === method}
            />
          ))}
        </VBox>
      </ContentBox>
    </LoginLayout>
  );
});

export default SsoReauthRequiredPage;
